import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { ToastContainer } from "react-toastify";

import {
  getStatusBgColor,
  interestLevel,
  leadStatusMap,
  statusIcons,
} from "../../../Enum";
import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import LocationService from "../../Services/LocationService";
import teamService from "../../Services/TeamService";
import leadSourceService from "../../Services/LeadSourceService";
import userServices from "../../Services/UserService";
import LeadTable from "../../Form/LeadTable/LeadTable";
import LeadDbService from "../../Services/LeadDbService";
import LeadFilterSidebar from "./LeadFilterSidebar";
import { useLocation, useNavigate } from "react-router-dom";
import ReasignModal from "./ReasignModel";
import { showErrorToast, showInfoToast } from "../../Constant/Notification";
import { teamIds, teamList } from "../../../utils/storage";
import { format } from "date-fns";
import CustomTruncatedText from "../../common/CustomTruncatedText";
import CustomChip from "../../common/CustomChip";
import { formatToIndianDate } from "../../../utils/dateFormatter";
import { status } from "../../../Enum/LeadEnumConstants";

const ReasignMain = () => {
  const location = useLocation();
  console.log(location.state);

  // User Info to user id and team Id

  const userId = location.state?.userId || null;
  const teamId = location.state?.teamId || null;
  const filterOpen = location.state?.filterOpen;

  console.log(
    "Team Id",
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : "No teamId"
  );

  const defaultTeamId =
    Array.isArray(teamIds) && teamIds.length > 0 ? teamIds[0] : teamId;

  const [filterVisible, setFilterVisible] = useState(filterOpen || false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(userId || null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(defaultTeamId || null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFilterApplyed , setIsFilterApplied] = useState(false);
    const [leadSource , setLeadSource] = useState([]);
    const [leadSourceSearch , setLeadSourceSearch] = useState("");
    const [selectedLeadSource, setSelectedLeadSource] = useState(null);


  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.id);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.id}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.id}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.id}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.id}`;
    }
    navigate(path, { state: { lead } });
  };

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          className="text-blue-500 w-[160px] text-nowrap truncate cursor-pointer"
        >
          {/* {text.replace(/\b\w/g, (char) => char.toUpperCase())} */}
          <CustomTruncatedText text={text} maxLength={35} />
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className=" w-[160px] text-nowrap truncate">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return <span className="text-gray-600">Unknown</span>;

        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex items-center text-center justify-center gap-2  rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5 "
            />
            <span className=" text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "Quality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find(
          (item) => item.label === value
        );

        return (
          <div className="flex items-center text-center gap-2">
            <img
              src={matchedQuality.image}
              alt={matchedQuality.label}
              className="w-5 h-5 "
            />
            <span className={`${getBackgroundClass(matchedQuality.label)} `}>
              {matchedQuality.label}
            </span>
          </div>
        );
      },
    },

    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");

        return (
          <span
            className="inline-block cursor-pointer max-w-[170px] truncate whitespace-nowrap overflow-hidden"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    ,
    {
      key: "teamName",
      title: "Team",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] cursor-pointer text-nowrap truncate"
          >
            {value}
          </div>
        );
      },
    },
    {
      key: "userName",
      title: "Assigned To",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] cursor-pointer text-nowrap truncate"
          >
            {value}
          </div>
        );
      },
    },
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const removalCountRef = useRef(0);

  const applyFilter = (removalChip) => {
    setIsFilterApplied(true)
    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }

    console.log("applyFilter", removalChip);

    // Compute what the new state will be after the chip is removed
    const level = removalChip === "quality" ? null : selectedLevel;
    const status = removalChip === "status" ? null : selectedStatus;
    const location = removalChip === "location" ? null : interestLocationTags;
    const team = removalChip === "team" ? null : selectedTeam;
    const user = removalChip === "user" ? null : selectedUser;
    const start = removalChip === "startDate" ? null : formattedStartDate;
    const end = removalChip === "startDate" ? null : formattedEndDate;
    const leadSource = removalChip === "source" ? null : selectedLeadSource;
    const noFiltersSelected =
      !level &&
      !status &&
      (!location || location.length === 0) &&
      !team &&
      !user &&
      !start &&
      !end && !leadSource;

    if (noFiltersSelected) {
      showInfoToast("No filters selected. Please apply at least one.");
      setIsFilterApplied(false)
      setLeads([]);
      setHasMoreLeads(false);
      setLeadCache({});
      return;
    }

    const newPageSize = 10;
    setLeadCache({});

    handleApplyFilter(null, "reset", newPageSize, 1, removalChip);
    console.log("Applying filter with removal chip:", removalChip);
  };

  const handleApplyFilter = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    removalChip
  ) => {
    setLoading(true);
    console.log("handleApplyFilter", removalChip);
    try {
      let targetPage = overridePage ?? currentPage;

      if (direction === "next") {
        targetPage += 1;
      } else if (direction === "previous") {
        targetPage = Math.max(targetPage - 1, 1);
      } else if (direction === "reset") {
        targetPage = 1;
      }

      if (leadCache[targetPage] && !removalChip) {
        const cached = leadCache[targetPage];
        setLeads(cached.leads);
        setNextPageToken(cached.next);
        setPrevPageToken(cached.prev);
        setHasMoreLeads(!!cached.next);
        setCurrentPage(targetPage);
        return;
      }

      const body = {
        searchKey: searchQuery || null,
        status: removalChip == "status" ? null : selectedStatus || null,
        quality: removalChip == "quality" ? null : selectedLevel?.label || null,
        location:
          removalChip == "location"
            ? null
            : interestLocationTags?.value || null,
        team: removalChip == "team" ? null : selectedTeam || defaultTeamId,
        user: removalChip == "user" ? null : selectedUser || null,
        leadSourceId : removalChip === "source" ? null : selectedLeadSource?.id || null,
        startDate:
          removalChip == "startDate" ? null : formattedStartDate || null,
        endDate: removalChip == "startDate" ? null : formattedEndDate || null,
        limit: limitOverride ?? pageSize,
        next: direction === "next" ? pageToken : null,
        previous: direction === "previous" ? pageToken : null,
        direction,
      };

      const filterData = await LeadDbService.getFilteredLeadList(body);
      const newLeads = filterData.data.leads;
      const newNext = filterData.data.next;
      const newPrev = filterData.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setFilterVisible(false);
      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
    } catch (error) {
      console.error("Error fetching filtered leads:", error);
    } finally {
      setLoading(false);
    }
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    handleApplyFilter(null, "reset", pageSize, 1, true);
  }, [pageSize]);

  const handlePageChange = (tokenOrValue, direction) => {
    console.log(tokenOrValue);
    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);
      handleApplyFilter(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      setCurrentPage((prev) => prev + 1);
      handleApplyFilter(nextPageToken, "next");
    } else if (direction === "previous") {
      setCurrentPage((prev) => Math.max(prev - 1, 1));
      handleApplyFilter(prevPageToken, "previous");
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setIsFilterApplied(false)
      setSelectedLevel(null);
      setInterestedLocationTags([]);
      setSelectedTeam(userRole === "BOD" ? defaultTeamId : null);
      setSelectedLeadSource("")
      setLeadSourceSearch("")
      setSelectedUser("");
      setStartDate("");
      setEndDate("");
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
 
    applyFilter();
    setLeadSourceSearch("")
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
    console.log("All selected IDs:", selectedIds);
  };



  const fetchLeadSourceData = async ()=>{

    try{
      const response = await leadSourceService.getLeadSource(leadSourceSearch)
      console.log(response.data)
       setLeadSource(response.data)

    }catch(error){
      console.log(error)
      setLeadSource([])
    }
  }
  useEffect(()=>{
    fetchLeadSourceData()
  },[leadSourceSearch])
  useEffect(() => {
    (async () => {
      try {
        const responseLocation = await LocationService.fetchLocation();
        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }

      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchTeamUsers = async () => {
      if (!selectedTeam) {
        setUsers([]);
        return;
      }

      setIsLoading(true);
      try {
        const selected = selectedTeam || defaultTeamId;
        const response = await teamService.getTeamData(selected);
        const data = response.data;

        const combinedUsers = [
          ...(Array.isArray(data.BOD) && data.BOD.length > 0
            ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
            : []),
          ...(data.MD && data.MD.name !== null && data.MD.id !== null
            ? [{ name: data.MD.name, id: data.MD.id }]
            : []),
          ...(Array.isArray(data.members) && data.members.length > 0
            ? data.members.map((member) => ({
                name: member.name,
                id: member.id,
              }))
            : []),
        ];

        const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
        setUsers(finalUsers);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTeamUsers();
  }, [selectedTeam]);

  const handleBack = () => {
    window.history.back();
  };

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    console.log(e);
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedLevel(selectedOption);
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const handleSearchLead = () => {
    setLeadCache({});

    if (userRole === "BOD") {
      const level = selectedLevel;
      const status = selectedStatus;
      const location = interestLocationTags;
      const team = selectedTeam;
      const user = selectedUser;
      const start = formattedStartDate;
      const end = formattedEndDate;

      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !user &&
        !start &&
        !end;

      if (searchQuery.trim() !== "" || !noFiltersSelected) {
        handleApplyFilter();
      }
    } else {
      const level = selectedLevel;
      const status = selectedStatus;
      const location = interestLocationTags;
      const team = selectedTeam;
      const user = selectedUser;
      const start = formattedStartDate;
      const end = formattedEndDate;

      const noFiltersSelected =
        !level &&
        !status &&
        (!location || location.length === 0) &&
        !team &&
        !user &&
        !start &&
        !end;

      if (searchQuery.trim() !== "" || !noFiltersSelected) {
        handleApplyFilter();
      }
    }
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const path =
    userRole === "Admin" ? "/admin" : userRole === "CMO" ? "/cmo" : "/bod";

  const handleReasignTeam = () => {
    navigate(`${path}/lead/reassign`, {
      state: {
        leadListArray: selectedRows,
        teamId: selectedTeam,
        memberId: selectedUser,
        leadCount: selectedRows.length,
      },
    });
  };

  const handleRemove = (filterKey) => {
    switch (filterKey) {
      case "status":
        setSelectedStatus(null);
        break;
      case "quality":
        setSelectedLevel(null);
        break;
      case "location":
        setInterestedLocationTags(null);
        break;
      case "team":
        setSelectedTeam(null);
        setSelectedUser(null);
        break;
      case "user":
        setSelectedUser(null);
        break;
        case "source":
          setSelectedLeadSource(null);
          setLeadSourceSearch("")
          break;
      case "startDate":
        setStartDate(null);
        setEndDate(null);
        break;
      default:
        return;
    }

    applyFilter(filterKey);
  };

  console.log("Location ", interestLocationTags);

  const handleReasignOtherTeam = () => {};

  console.log("Selected User:", selectedUser);
  console.log("Selected Team:", selectedTeam);
  return (
    <div className="pt-14 bg-appGrayBackground ">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-[50px] px-6">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <BackArrows onClick={handleBack} />
              <h1 className="text-[32px] font-semibold">Reassign</h1>
            </div>
          </div>
          <div>
            {isFilterApplyed && (  <div className="flex items-center gap-5 flex-wrap">
             
             <div>Applied Filtered :</div>
             {/* Status */}
             {selectedStatus && (
               <CustomChip
                 value={selectedStatus}
                 onRemove={() => handleRemove("status")}
               />
             )}

             {/* Interest Level */}
             {selectedLevel && (
               <CustomChip
                 value={selectedLevel.label}
                 onRemove={() => handleRemove("quality")}
               />
             )}

             {/* Locations */}
             {interestLocationTags?.label && (
               <CustomChip
                 value={interestLocationTags.label}
                 onRemove={() => handleRemove("location")}
               />
             )}

             {/* Team */}
             {userRole !== "BOD" && selectedTeam && (
               <CustomChip
                 value={
                   teams.find((team) => team.teamId === selectedTeam)?.name ||
                   selectedTeam
                 }
                 onRemove={() => handleRemove("team")}
               />
             )}
              {selectedLeadSource && (
                <CustomChip
                  value={selectedLeadSource.label}
                  onRemove={() => handleRemove("source")}
                />
              )}

             {/* User */}
             {selectedUser && (
               <CustomChip
                 value={
                   users.find((user) => user.id === selectedUser)?.name ||
                   selectedUser
                 }
                 onRemove={() => handleRemove("user")}
               />
             )}

             {/* Date Range */}
             {(startDate || endDate) && (
               <CustomChip
               
                 value={`Date: ${formatToIndianDate(
                  startDate
                )} - ${formatToIndianDate(endDate)}`}
                 onRemove={() => handleRemove("startDate")}
               />
             )}
           </div>)}
          
          </div>
        </div>
      </div>

      <LeadFilterSidebar
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        optionLocation={optionLocation}
        interestLocationTags={interestLocationTags}
        handleLocationChange={handleLocationChange}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        getBackgroundClass={getBackgroundClass}
        leadSource={leadSource}
        setLeadSourceSearch ={setLeadSourceSearch}
        setSelectedLeadSource={setSelectedLeadSource}
        selectedLeadSource={selectedLeadSource}
        leadSourceSearch={leadSourceSearch}
        teams={teams}
        selectedTeam={selectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        endType={endType}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
      />

      <div className="mt-[40px] px-6">
        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleSearchLead={handleSearchLead}
          handleReasignTeam={handleReasignTeam}
          searchQuery={searchQuery}
          loading={loading}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          isReassign={true}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
        <ReasignModal
          isOpen={showReassignModal}
          onClose={() => setShowReassignModal(false)}
          onReasignTeam={handleReasignTeam}
          onReasignOtherTeam={handleReasignOtherTeam}
        />
      </div>
    </div>
  );
};

export default ReasignMain;
